import React, { useRef, useState } from 'react';
import { campaignErrorMessage, updateCampaignStatus } from '../api/adpilotApi';

export default function WatchedCampaignActions({ campaign, connection, user, disabled, onChanged, onUnwatch }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);
  const inFlight = useRef(false);
  const status = String(campaign.status || '').toUpperCase();
  const canChange = (!connection?.access_role || connection.access_role === 'owner')
    && campaign.available !== false && !campaign.stale
    && ['ACTIVE', 'ENABLED', 'PAUSED'].includes(status);
  const activate = status === 'PAUSED';
  const label = activate ? 'Activate' : 'Pause';
  const changeStatus = async () => {
    if (disabled || inFlight.current) return;
    if (activate && !window.confirm(`Activate “${campaign.name || 'this campaign'}”?\n\nIt can start spending according to its existing budget and schedule. Ad sets and ads keep their current statuses.`)) return;
    inFlight.current = true;
    setPending(true); setError(null);
    try {
      const result = user.preview
        ? { status: activate ? 'ACTIVE' : 'PAUSED' }
        : await updateCampaignStatus({ userId: user.id, connectionId: connection.connection_id,
          platformCampaignId: campaign.platform_campaign_id, status: activate ? 'ACTIVE' : 'PAUSED', expectedStatus: campaign.status });
      onChanged({ ...campaign, status: result.status, ...(result.sync ? { stale: result.sync.stale } : {}) });
      if (result.sync?.stale) setError('Delivery status was confirmed, but other Meta details could not be refreshed. Refresh from Meta to check the account.');
    } catch (changeError) {
      setError(campaignErrorMessage(changeError, 'Could not change campaign status. Refresh and try again.'));
    } finally { inFlight.current = false; setPending(false); }
  };
  return (
    <div className="watched-campaign-actions">
      <div className="watched-campaign-buttons">
        {canChange && <button type="button" className="campaign-status-toggle" disabled={disabled || pending}
          aria-label={`${label} ${campaign.name || 'campaign'}`} onClick={changeStatus}>
          {pending ? (activate ? 'Activating…' : 'Pausing…') : label}
        </button>}
        <button type="button" className="text-button" disabled={disabled || pending} onClick={onUnwatch}>Stop watching</button>
      </div>
      {error && <p className="watched-campaign-error" role="alert">{error}</p>}
    </div>
  );
}
